import { GridLegacy as Grid } from '@mui/material';
import BorderBox from '../../BorderBox';

const EquipmentDetailBox = ({ equip }) => {
  function extractDevice(e, extractFn) {
    return (e.devices ?? []).map((device) => extractFn(device));
  }

  return (
    <Grid item xs={12}>
      <BorderBox title="Equipment Details" sx={{ mx: '20px', borderRadius: 0 }}>
        <Grid container>
          <Grid item xs={6}>
            Device IDs: {extractDevice(equip, (d) => d.device_id).join(', ') || 'None'}
          </Grid>
          <Grid item xs={6}>
            Name: {extractDevice(equip, (d) => d.name).join(', ') || 'None'}
          </Grid>
          <Grid item xs={6}>
            Program Locations:{' '}
            {extractDevice(equip, (d) => JSON.stringify(d?.properties?.deviceProgramLocation)).join(
              ', '
            ) || 'None'}
          </Grid>
          <Grid item xs={6}>
            Software Versions:{' '}
            {extractDevice(equip, (d) =>
              JSON.stringify(d?.properties?.applicationSoftwareVersion)
            ).join(', ') || 'None'}
          </Grid>
        </Grid>
      </BorderBox>
    </Grid>
  );
};

export default EquipmentDetailBox;
